import React, { useCallback, useEffect, useState } from "react";
import { useAuth } from "react-oidc-context";
import jwt_decode from 'jwt-decode';
import validateSession from "../services/validateSessionService";
import { SessionExpired } from "../components/session-expired/SessionExpired";

const AuthComponent = ({ children }) => {
    const { isAuthenticated, error, isLoading, signinRedirect, settings, user, removeUser, revokeTokens, events } = useAuth();
    const [tokenIsProvided, setTokenIsProvided] = useState(false)
    const [isAdpLoading, setIsAdpLoading] = useState<boolean>(true);

    const configureGetTheTokenGlobalFunc = useCallback(() => {
        window.getTheToken = function () { return user?.access_token! };
        setTokenIsProvided(true);
    }, [user])

    const isAdp = () => {
        let decodedToken;
        if (user?.id_token) {
            decodedToken = jwt_decode(user?.access_token)
            return decodedToken["Company Type"] === "ADP" || decodedToken["Profile_BusinessType"] === "ADP";
        }
    }

    const validateUserSession = useCallback(async () => {
        if (tokenIsProvided) {
            let sessionIsValid = await validateSession();

            if (!sessionIsValid) {
                removeUser();
                revokeTokens();
                setTokenIsProvided(false);
            }
        }
    }, [tokenIsProvided, removeUser, revokeTokens]);

    const validateUserSessionTimer = useCallback(() => {
        window.setInterval(async () => { await validateUserSession() }, 7000);
    }, [validateUserSession])

    useEffect(() => {
        if (settings.authority && !isLoading) {
            !isAuthenticated ?
                signinRedirect() :
                !isAdp() ? (window.location.href = "https://start.docuware.com") : setIsAdpLoading(false);
        }
        configureGetTheTokenGlobalFunc();
        validateUserSession();
        validateUserSessionTimer();

        // the `return` is important - addAccessTokenExpiring() returns a cleanup function
        return events.addAccessTokenExpiring(() => {
            setTokenIsProvided(false);
        })

    }, [isAuthenticated, signinRedirect, settings.authority, isLoading, configureGetTheTokenGlobalFunc, events])

    if (settings) {
        if (isAdpLoading) return <div>Loading...</div>;
        if (error) return <SessionExpired />;

        return children;
    }

    return null;
}

declare global {
    interface Window {
        getTheToken(): string;
    }
}

export default AuthComponent;